import {AfterViewInit, Directive, ElementRef, Input, Renderer2} from '@angular/core';

import {HandlePropChanges} from '../shared';

@Directive({
  selector: 'a[mz-icon-mdi], a[mzIconMdi], i[mz-icon-mdi], i[mzIconMdi]',
})
export class MzIconMdiDirective extends HandlePropChanges implements AfterViewInit {
  @Input() align: string;
  @Input() flip: string;
  @Input() icon: string;
  @Input() rotate: string;
  @Input() size: string;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    super();
  }

  ngAfterViewInit() {
    this.initHandlers();
    this.initMaterialize();
    super.executePropHandlers();
  }

  initHandlers() {
    this.handlers = {
      align: (previousValue) => this.handleAlign(previousValue),
      flip: (previousValue) => this.handleFlip(previousValue),
      icon: (previousValue) => this.handleIcon(previousValue),
      rotate: (previousValue) => this.handleRotate(previousValue),
      size: (previousValue) => this.handleSize(previousValue),
    };
  }

  initMaterialize() {
    this.renderer.addClass(this.elementRef.nativeElement, 'mdi');
  }

  handleAlign(previousValue?: string) {
    if (previousValue) {
      this.renderer.removeClass(this.elementRef.nativeElement, previousValue);
    }
    if (this.align) {
      this.renderer.addClass(this.elementRef.nativeElement, this.align);
    }
  }

  handleFlip(previousValue?: string) {
    if (previousValue) {
      this.renderer.removeClass(this.elementRef.nativeElement, 'mdi-flip-' + previousValue);
    }

    if (!!this.flip) {
      this.renderer.addClass(this.elementRef.nativeElement, 'mdi-flip-' + this.flip);
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'mdi-flip-' + this.flip);
    }
  }

  handleIcon(previousValue?: string) {
    if (previousValue) {
      this.renderer.removeClass(this.elementRef.nativeElement, 'mdi-' + previousValue);
    }
    this.renderer.addClass(this.elementRef.nativeElement, 'mdi-' + this.icon);
  }

  handleRotate(previousValue?: string) {
    if (previousValue) {
      this.renderer.removeClass(this.elementRef.nativeElement, 'mdi-rotate-' + previousValue);
    }

    if (!!this.rotate) {
      this.renderer.addClass(this.elementRef.nativeElement, 'mdi-rotate-' + this.rotate);
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'mdi-rotate-' + this.rotate);
    }
  }

  handleSize(previousValue?: string) {
    if (!this.size) {
      this.size = '24px';
    }
    if (previousValue) {
      this.renderer.removeClass(this.elementRef.nativeElement, 'mdi-' + previousValue);
    }
    this.renderer.addClass(this.elementRef.nativeElement, 'mdi-' + this.size);
  }
}
